<template>
  <div class="addDriver" style="border:1px solid #e0e0e0;">
    <div class="titleForm-container">添加司机信息</div>
    <div class="content-form-container">
      <div class="main-container-form">
        <el-form :model="baseForm" :rules="rules" ref="baseForm" label-width="100px" class="ruleForm">
          <el-form-item label="姓名" prop="name">
            <el-input v-model="baseForm.name" size="medium" style="width:100%;" placeholder="请输入真实姓名" onKeypress="javascript:if(event.keyCode == 32)event.returnValue = false;" :maxlength="num20">
            </el-input>
          </el-form-item>
          <el-form-item label="联系电话" prop="phone">
            <el-input v-model="baseForm.phone" size="medium" style="width:100%;" placeholder="请输入联系电话" onKeypress="javascript:if(event.keyCode == 32)event.returnValue = false;" :maxlength="num11">
            </el-input>
          </el-form-item>
          <el-form-item label="所属公司" prop="enterprise">
            <el-input v-model="baseForm.enterprise" size="medium" style="width:100%;" placeholder="请输入所属公司" onKeypress="javascript:if(event.keyCode == 32)event.returnValue = false;" :maxlength="num30">
            </el-input>
          </el-form-item>
           <el-form-item label="车牌号" prop="carNo">
            <el-input v-model="baseForm.carNo" size="medium" style="width:100%;" placeholder="请输入正确的车牌号" onKeypress="javascript:if(event.keyCode == 32)event.returnValue = false;" :maxlength="num30">
            </el-input>
          </el-form-item>
           <el-form-item label="道路运输证" prop="driverNo">
            <el-input v-model="baseForm.driverNo" size="medium" style="width:100%;" placeholder="请输入正确的道路运输证" onKeypress="javascript:if(event.keyCode == 32)event.returnValue = false;" :maxlength="num30">
            </el-input>
          </el-form-item>
          <el-form-item label="相关图片" prop="images">
            <div class="uploadWall">
              <base-upload v-for="(item,index) in list" :key="index" :listObj="item" @transImg="transImg" @removeImg="removeImg"></base-upload>
            </div>
            
            <el-dialog :visible.sync="dialogVisible">
              <img width="100%" :src="dialogImageUrl" alt="">
            </el-dialog>
          </el-form-item>
          <el-form-item class="save-cancel" v-if="edit">
            <el-col :span="8">
              <el-button class="save-btn" @click="saveBase('baseForm')" :loading="loadingtype">保存</el-button>
            </el-col>
            <el-col :span="8">
              <el-button class="cancel-btn" @click="cancelForm('ruleForm')">取消</el-button>
            </el-col>
          </el-form-item>
        </el-form>
      </div>
    </div>
  </div>
</template>


<script>
import { mapActions, mapState } from "vuex";
import { modules } from "../../../store";
import imgUpload from "../../../service/base-url";
import BaseUpload from "./BaseUpload";
import mixins from "@/common/MixIn.js";
export default {
  name: "AddDriver",
  mixins: [mixins],
  components: {
    BaseUpload
  },
  data() {
    return {
      uploadList: {
        idCardFront: "",
        idCardReverse: "",
        driverLicense: "",
        transportPermit: "",
        drivingLicense: "",
        photo: ""
      },
      loadingtype: false,
      list: [
        {
          remark: 1,
          hide: false,
          uploadURl: imgUpload.imgUpload + "?Remark=1",
          url: "",
          tip: "点击上传身份证（正面）",
          desc: "身份证(正面)"
        },
        {
          remark: 2,
          hide: false,
          uploadURl: imgUpload.imgUpload + "?Remark=2",
          url: "",
          tip: "点击上传身份证（反面）",
          desc: "身份证(反面)"
        },
        {
          remark: 3,
          hide: false,
          uploadURl: imgUpload.imgUpload + "?Remark=3",
          url: "",
          tip: "点击上传驾照",
          desc: "驾照"
        },
        {
          remark: 4,
          hide: false,
          uploadURl: imgUpload.imgUpload + "?Remark=4",
          url: "",
          tip: "点击上传道路运输证",
          desc: "道路运输证"
        },
        {
          remark: 5,
          hide: false,
          uploadURl: imgUpload.imgUpload + "?Remark=5",
          url: "",
          tip: "点击上传行驶证(第一、二页)",
          desc: "行驶证(第一、二页)"
        },
        {
          remark: 6,
          hide: false,
          uploadURl: imgUpload.imgUpload + "?Remark=6",
          url: "",
          tip: "点击上传司机与车辆合照",
          desc: "司机与车辆合照"
        }
      ],
      imageUrl: "",
      dialogImageUrl: "",
      dialogVisible: false,
      num20: 20,
      num11: 11,
      num30: 30,
      index: "",
      kk: {
        remark: "11"
      },
      imgList: [],
      fileList: [],
      // 参数
      baseForm: {
        name: "",
        phone: "",
        carNo: "", //车牌号
        driverNo: "", // 驾驶证号
        enterprise: "", //公司名称
        images: [] //图片
      },
      // 校验规则
      rules: {
        name: [
          {
            required: true,
            message: "请先输入真实姓名",
            trigger: "blur"
          },
          {
            pattern: /^[a-zA-Z\u4e00-\u9fa5]+$/,
            message: "真实姓名格式不对,请重新输入"
          }
        ],
        phone: [
          { required: true, message: "请先输入有效联系电话" },
          {
            pattern: /^1[3|4|5|7|8|9][0-9]\d{8}$/,
            message: "联系电话格式不对,请重新输入"
          }
        ],
        carNo: [
          { required: true, message: "请先输入车牌号", trigger: "blur" },
          {
            pattern: /^[a-zA-Z0-9.\u4e00-\u9fa5]+$/,
            message: "车牌号格式不对,请重新输入"
          }
        ],
        driverNo: [
          { required: true, message: "请先输入道路运输证", trigger: "blur" },
          {
            pattern: /^[0-9]+$/,
            message: "车牌号格式不对,请重新输入"
          }
        ],
        enterprise: [
          // { required: true, message: "请先输入所属公司", trigger: "blur" },
          {
            pattern: /^[\u4e00-\u9fa5]+$/,
            message: "所属公司格式不对,请重新输入"
          }
        ]
      },
      uploadURl: imgUpload.imgUpload // 文件上传地址
    };
  },
  methods: {
    ...mapActions(modules.driverManage, {
      addDriver: "addDriver"
    }),
    distribution(arr) {
      arr.forEach(ele => {
        this.baseForm.images.push(ele.name);
      });
    },
    // 上传图片
    transImg(res) {
      let haveEqual = this.imgList.find((item, index) => {
        if (item.remark == res.remark) {
          this.imgList.splice(index, 1, res);
          return true;
        }
      });
      if (!haveEqual) {
        this.imgList.push(res);
      }
    },
    // 删除图片
    removeImg(e) {
      this.imgList.find((item, index) => {
        if (item.remark == e) {
          this.imgList.splice(index, 1);
          return true;
        }
      });
    },
    //保存
    async saveBase(formName) {
      this.$refs[formName].validate(async valid => {
        if (valid) {
          this.distribution(this.imgList);
          // 参数
          let obj = {
            name: this.baseForm.name,
            phone: this.baseForm.phone,
            carNo: this.baseForm.carNo,
            driverNo: this.baseForm.driverNo,
            enterprise: this.baseForm.enterprise,
            images: this.baseForm.images
          };
          this.loadingtype = true;
          // post 请求
          this.addDriver(obj)
            .then(data => {
              this.$message({
                message: "保存成功",
                type: "success"
              });
              this.loadingtype = false;
              this.$router.push({
                name: "driverList"
              });
            })
            .catch(err => {
              this.$Alert.info({
                content: err.response.data,
                duration: 5000,
                status: "error"
              });
              // this.$message.error(err.response.data);
            });
        } else {
          return false;
        }
      });
    },
    //取消
    cancelForm() {
      this.$router.push({
        name: "driverList"
      });
    }
  }
};
</script>
<style lang="stylus">
.uploadWall
  display: flex !important;
  flex-direction row
  flex-wrap wrap 
  width:700px;
  .avatar{
    width:146px;
    height:146px;
  }
  >div
    margin-right:50px;


.remark1 .el-upload{
  display:none;
}
</style>

<style lang="stylus" scoped>
.desc
  text-align: center;
  color:#666;
</style>
